import { Box, Button, Paper, TextField } from "@mui/material";
import ReactJson from "@uiw/react-json-view";
import { useState } from "react";
import Page from "../components/Page";
import {
  StatusPacket,
  useOnboardMutation,
  useVerifyOTPMutation,
} from "../data/business";

export default function Onboard() {
  const [gstin, setGstin] = useState("");
  const [username, setUsername] = useState("");
  const [otp, setOtp] = useState("");
  const [startOnboarding, setStartOnboarding] = useState(false);

  const [response, setResponse] = useState<StatusPacket | undefined>(undefined);

  const onboardMutation = useOnboardMutation();
  const verifyOTPMutation = useVerifyOTPMutation();

  return (
    <Page title="Onboard">
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <TextField
          label="GSTIN"
          type="text"
          value={gstin}
          onChange={(e) => setGstin(e.target.value)}
        />
        <TextField
          label="Username"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        {startOnboarding && (
          <>
            <TextField
              label="OTP"
              type="number"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          </>
        )}

        {!startOnboarding && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setStartOnboarding(true);
              onboardMutation.mutate(
                { gstin, username },
                { onSuccess: (data) => setResponse(data) },
              );
            }}
          >
            Onboard
          </Button>
        )}

        {startOnboarding && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              verifyOTPMutation.mutate(
                { gstin, otp },
                { onSuccess: (data) => setResponse(data) },
              );
            }}
          >
            Verify OTP
          </Button>
        )}

        {response && (
          <Paper sx={{ padding: 2 }}>
            <ReactJson
              value={response}
              collapsed={1}
              style={{
                padding: 2,
              }}
            />
          </Paper>
        )}
      </Box>
    </Page>
  );
}
